import React, {ReactNode} from 'react';
import classNames from '../../lib/class-names';

type Props = {
    children: [ReactNode, ReactNode],
    className?: string,
};

export default function OneTwoLayout(props: Props) {
    const [child1, child2] = props.children;
    return <div className={classNames('md:grid md:grid-cols-3 md:gap-6', props.className)}>
        <div className="md:col-span-1">
            {child1}
        </div>
        <div className="mt-5 md:mt-0 md:col-span-2">
            {child2}
        </div>
    </div>;
}